import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";
import type { SyncStudiomateMembersResponse } from "@vlab-corporation/studiomate-api";

export async function triggerMemberSync(): Promise<SyncStudiomateMembersResponse> {
  const fn = httpsCallable<Record<string, never>, SyncStudiomateMembersResponse>(
    getFirebaseFunctions(),
    "syncStudiomateMembers",
  );
  const result = await fn({});
  if (!result.data.success) {
    throw new Error(result.data.error?.message ?? "회원 동기화에 실패했습니다.");
  }
  return result.data;
}
